<script setup lang="ts">
import { logoDark } from '@therobotcompany/robco-frontend-library';
import gettext from '@/i18n/gettext';

const props = defineProps<{
  title: string;
  type: string;
  description: string;
  href: string;
}>();

const { $gettext } = gettext;
</script>

<template>
  <v-card :href="href" class="h-100" target="_blank" rel="noopener noreferrer">
    <v-card-title class="ma-2">
      <v-avatar
        size="30"
        class="color-unset"
        style="vertical-align: top; margin-top: 1px"
      >
        <img :src="logoDark" alt="RobCo Logo" width="30" height="30" />
      </v-avatar>
      <span class="resource-card-title">{{ props.title }}</span>
      <v-chip
        class="gradient-sunrise-apricot float-end"
        color="surface"
        style="height: 20px; margin-top: 6px"
        :label="true"
      >
        {{ props.type.toLowerCase() }}
      </v-chip>
    </v-card-title>
    <v-card-text class="ma-2">
      <div class="mb-8">{{ props.description }}</div>
      <div class="resource-card-bottom">
        <v-divider />
        <span class="resource-card-bottom__content"
          >{{ $gettext('Open') }}
          <v-icon class="float-end">mdi-open-in-new</v-icon>
        </span>
      </div>
    </v-card-text>
  </v-card>
</template>
<style lang="scss">
.resource-card-title {
  position: relative;
  display: inline-block;
  width: calc(100% - 88px);
  padding-left: 8px;
  white-space: break-spaces;
}
.resource-card-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 40px;

  &__content {
    font-weight: bold;
    height: 100%;
    padding: 10px 24px;
    position: relative;
    display: block;
    vertical-align: center;
  }
}
</style>
